import { render, staticRenderFns } from "./LmQmsButton.vue?vue&type=template&id=6db23077&scoped=true&"
import script from "./LmQmsButton.vue?vue&type=script&lang=js&"
export * from "./LmQmsButton.vue?vue&type=script&lang=js&"
import style0 from "./LmQmsButton.vue?vue&type=style&index=0&id=6db23077&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db23077",
  null
  
)

export default component.exports